export const ERROR_DUPLICATE_MESSAGE = 'Markup already in collection'

export const API_BASE_PATH = '/v1/content-collections'

export const apiConfig = Object.freeze({
  ADD_ENTITY: `${API_BASE_PATH}/add_entity`,
  ADD_ENTITIES: `${API_BASE_PATH}/add_entities`,
  COLLECTION: (id: string) => `${API_BASE_PATH}/collection/${id}`,
  SHARED_COLLECTION: (id: string) => `${API_BASE_PATH}/shared/${id}`,
  CONTENT_COLLECTIONS: API_BASE_PATH,
  CREATE_CONTENT_COLLECTION: `${API_BASE_PATH}/create_content_collection`,
  DELETE_CONTENT_COLLECTION: `${API_BASE_PATH}/delete_content_collection`,
  REMOVE_ENTITY: `${API_BASE_PATH}/remove_entity`,
  UPDATE_CONTENT_COLLECTION_METADATA: `${API_BASE_PATH}/update_content_collection_metadata`,
})
